/* eslint-disable eag/match-named-export */
import {ThemeShadowsPath} from '../types/ThemePaths';

export const SHADOW_CLASSES: Record<ThemeShadowsPath, string> = {
  'elevation-1': 'shadow-[var(--shadow-elevation-1)]',
  'elevation-2': 'shadow-[var(--shadow-elevation-2)]',
  'elevation-3': 'shadow-[var(--shadow-elevation-3)]',
  'elevation-4': 'shadow-[var(--shadow-elevation-4)]',
  active: 'shadow-[var(--shadow-active)]',
};
